// import { coreConfig } from "../modules/core/config";

// const dd = (data) => {
// };

const differenceBy = (data, selected, title) => {
  const results = data.filter(
    ({ id: id1 }) => !selected.some(({ id: id2 }) => id2 === id1)
  );

  return results;
};

// convert english number to farsi
const toFarsiNumber = (num) => {
  const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  return num
    .toLocaleString()
    .toString()
    .replace(/\d/g, (x) => farsiDigits[x]);
};

// get window size
const getWindowSize = () => {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
};

// this must be custom hook

// // outside of components click handler
// const outSideClickHandler = (callback) => {
//   const loginForm = useRef();

//   useEffect(() => {
//     const handleClick = (event) => {
//       if (loginForm.current && !loginForm.current.contains(event.target)) {
//         callback();
//       }
//     };

//     document.addEventListener("click", handleClick, true);

//     return () => {
//       document.removeEventListener("click", handleClick, true);
//     };
//   }, [loginForm]);

//   return loginForm;
// };

// unique id generator
const idGenerator = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

const getFormData = (e) => {
  const data = new FormData(e.target);
  const formObject = Object.fromEntries(data.entries());

  return formObject;
};

const dropDownObject = (object, ticket) => {
  const newObj = [];

  object.forEach((obj, i) => {
    newObj.push({
      code: ticket ? i : obj.id,
      name: ticket ? obj.name_fa : obj.name,
    });
  });

  return newObj;
};

const translateLabel = (fa, label) => {
  return fa[label];
};

// limit string character
const limitString = (msg, character) => {
  let message;
  if (msg?.length > character) {
    message = msg.substring(0, character);
    return message + "...";
  } else {
    message = msg;
    return msg;
  }
};

const getChildrens = (rootCat) => {
  if (!rootCat.hasOwnProperty("name")) throw new Error("isnt root category");
  const root = {
    key: rootCat.id,
    parent_id: rootCat.parent_id,
    label: rootCat.name,
    data: `${rootCat.name}-data`,
    children: [],
  };
  if (rootCat.hasOwnProperty("children")) {
    const newChilds = [];
    rootCat.children.forEach((child) => {
      newChilds.push(getChildrens(child));
    });

    root.children = newChilds;
  }

  return root;
};

const tagsObject = (tags) => {
  const newTag = [];

  tags.forEach((tag) => {
    newTag.push({
      key: tag.id,
      label: tag.name ? tag.name : tag.title,
      slug: tag.slug,
    });
  });

  return newTag;
};

const accessObject = (tags, ticket) => {
  const newAccess = [];

  tags.forEach((tag, i) => {
    newAccess.push({
      key: ticket ? i : tag.name,
      label: tag.name_fa,
    });
  });

  return newAccess;
};

const selectedAccess = (items) => {
  const newItems = {};
  items &&
    items.forEach((item) => {
      newItems[item] = true;
    });

  return newItems;
};

const selectedItems = (items) => {
  const newItems = {};
  items &&
    items.forEach((item) => {
      const id = item.id;
      newItems[id] = true;
    });

  return newItems;
};

const randomColor = () => {
  const color = Math.floor(Math.random() * 16777215).toString(16);

  return color;
};

const ReservedTimes = (allTimes, selectedTimes) => {
  const reserved = [];

  allTimes.forEach((all) => {
    all.times.forEach((time) => {
      if (selectedTimes[time.time_id] === true) {
        reserved.push(time.time_id);
      }
    });
  });

  return reserved;
};

const ticketCatObject = (ticket, to) => {
  const newTag = [];

  ticket.forEach((tick, i) => {
    newTag.push({
      key: to ? tick.id : i,
      label: tick.name_fa,
    });
  });

  return newTag;
};

const addressObject = (add) => {
  const newTag = [];

  add.forEach((a, i) => {
    newTag.push({
      key: i,
      ...a,
    });
  });

  return newTag;
};

function codeGenerate(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

const toNested = (data, pid = null) => {
  return data.reduce((r, e) => {
    if (pid == e.parent_id) {
      const object = { ...e };
      const children = toNested(data, e.id);

      if (children.length) {
        object.children = children;
      }

      r.push(object);
    }
    return r;
  }, []);
};

const convertParent = (data) => {
  const arr = [];
  data.forEach((e) => {
    arr.push({
      ...e,
      parent_id: e.parent_id === null ? 0 : e.parent_id,
    });
  });

  return arr;
};

const convertProduct = (products) => {
  const newTag = [];

  products.forEach((product, i) => {
    newTag.push({
      key: product.id,
      label: product.name,
      slice: product.slice,
      price: product.price,
    });
  });

  return newTag;
};

const stringSeprator = (text) => {
  if (text.includes(":")) {
    const newText = text.split(":");
    return newText;
  } else {
    return text;
  }
};

const keywordStructure = (data) => {
  const newData = [];

  data.forEach((item) => {
    newData.push(item.keyword);
  });

  return newData;
};

export {
  stringSeprator,
  differenceBy,
  idGenerator,
  toFarsiNumber,
  getWindowSize,
  getFormData,
  translateLabel,
  limitString,
  getChildrens,
  randomColor,
  tagsObject,
  selectedItems,
  ReservedTimes,
  accessObject,
  selectedAccess,
  ticketCatObject,
  addressObject,
  codeGenerate,
  toNested,
  convertParent,
  convertProduct,
  dropDownObject,
  keywordStructure
};
